<div id="doc-container">
  <div *ngIf="state == legalDocsState.Loading">Loading, please wait</div>
  <div [innerHTML]="legalHtml" *ngIf="state == legalDocsState.Loaded"></div>
  <div *ngIf="state == legalDocsState.Error">{{ errorMessage }}</div>
</div>
